import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpMetersComponent } from './rp-meters/rp-meters.component';
import { RpMetersViewComponent } from './rp-meters-view/rp-meters-view.component';
import { MetersDatabaseComponent } from './meters-database/meters-database.component';
import { EditMetersComponent } from './edit-meters/edit-meters.component';

const routes: Routes = [
  { path: 'meters', component: RpMetersComponent },
  { path: 'meters/metersView', component: RpMetersViewComponent },
  /* { path: 'metersDatabase', component: MetersDatabaseComponent },
  { path: 'meters/EditMeters', component: EditMetersComponent }, */
  { path: 'metersDatabase', component: MetersDatabaseComponent },
  { path: 'metersDatabase/EditMeters', component: EditMetersComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MetersRoutingModule {}
